"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Switch = void 0;
const SwitchPrimitives = __importStar(require("@radix-ui/react-switch"));
const class_variance_authority_1 = require("class-variance-authority");
const React = __importStar(require("react"));
const utils_1 = require("../../lib/utils");
const Label_1 = require("../Label/Label");
const MiniTag_1 = require("../MiniTag/MiniTag");
const switchVariants = (0, class_variance_authority_1.cva)([
    "tw-inline-flex tw-shrink-0 tw-cursor-pointer tw-items-center tw-rounded-full tw-border-2 tw-border-transparent tw-transition-colors",
    "focus-visible:tw-ring-ring focus-visible:tw-outline-none focus-visible:tw-ring-2 focus-visible:tw-ring-offset-2 focus-visible:tw-ring-offset-primaryDim-50",
    "disabled:tw-cursor-not-allowed disabled:tw-opacity-50 data-[state=checked]:tw-bg-primary-300",
], {
    variants: {
        size: {
            sm: "tw-h-5 tw-w-9",
            md: "tw-h-6 tw-w-[42px]",
            lg: "tw-h-7 tw-w-12",
        },
    },
    defaultVariants: {
        size: "md",
    },
});
const SwitchLabel = ({ selected, color, type, children, }) => type === "text" ? (React.createElement(Label_1.Label, { className: (0, utils_1.cn)("tw-font-semibold tw-transition-colors", {
        "tw-text-neutral-500": selected,
        "tw-text-neutral-200 tw-opacity-50": !selected,
    }) }, children)) : (React.createElement(MiniTag_1.MiniTag, { className: "tw-transition-colors", color: selected ? color : "grey", variant: selected ? "solid" : "default", size: "lg" }, children));
const Switch = React.forwardRef(({ className, size, left, right, labelType = "text", onCheckedChange, checked, defaultChecked, onValueChange, defaultValue, ...props }, ref) => {
    if (right && !left) {
        throw new Error("Switch: 'right' prop requires 'left' prop to be set.");
    }
    const [internalChecked, setInternalChecked] = React.useState(Boolean(checked ||
        (defaultValue && defaultValue === right?.value) ||
        defaultChecked));
    const handleSwitchChange = (isChecked) => {
        setInternalChecked(isChecked);
        // If no value is provided, acts the same as onCheckedChange
        onValueChange?.(isChecked ? right?.value || true : Boolean(left?.value));
        onCheckedChange?.(isChecked);
    };
    return (React.createElement("div", { className: "tw-inline-flex tw-items-center tw-justify-center tw-gap-2" },
        left && (React.createElement(SwitchLabel, { type: labelType, selected: 
            // If no right prop undefined and labelType is text, always show solid label
            right ? !internalChecked : labelType === "text" || internalChecked, color: "primary" }, left.label)),
        React.createElement(SwitchPrimitives.Root, { className: (0, utils_1.cn)(switchVariants({ size }), {
                "data-[state=checked]:tw-bg-primary-300 data-[state=unchecked]:tw-bg-primary-300": right,
                "data-[state=unchecked]:tw-bg-primaryDim-50": !right,
            }, className), onCheckedChange: handleSwitchChange, checked: checked, defaultChecked: internalChecked, ...props, ref: ref },
            React.createElement(SwitchPrimitives.Thumb, { className: (0, utils_1.cn)("tw-pointer-events-none tw-block tw-rounded-full tw-bg-neutral-25 tw-shadow-lg tw-ring-0 tw-transition-transform data-[state=unchecked]:tw-translate-x-1", {
                    "tw-h-3.5 tw-w-3.5 data-[state=checked]:tw-translate-x-4": size === "sm",
                    "tw-h-4 tw-w-4 data-[state=checked]:tw-translate-x-[1.35rem]": size === "md",
                    "tw-h-5 tw-w-5 data-[state=checked]:tw-translate-x-6": !size || size === "lg",
                }) })),
        right && (React.createElement(SwitchLabel, { type: labelType, selected: Boolean(internalChecked), color: "secondary" }, right.label))));
});
exports.Switch = Switch;
Switch.displayName = SwitchPrimitives.Root.displayName;
